<div class="navbar-wrapper"
  [ngClass]="{'container': this.gradientConfig.layout === 'horizontal' && this.gradientConfig.subLayout === 'horizontal-2'}">
  <img id="logo" src="../../../../../assets/images/logo-sanchai.png">
  <h6 id="title-text-c" style="color: black; margin-bottom: 2%;font-size: 13px;">
    สำนักงานปลัดกระทรวงเกษตรและสหกรณ์
  </h6>
  <app-nav-content (onNavMobCollapse)="navMobCollapse()"></app-nav-content>
</div>